<div class="form-group question" >
  <div class="header">

    @if (question.type !== AnswerType.FreeText) {
      <label [innerHTML]="question.title"
        [attr.for]="question.id"
        [id]="'labelFor-'+ question.id"
        [class.has-help-text]="!!question.body"
      ></label>
    }
    @if (question.body && !readonly) {
      <app-gphc-icon [tooltip]="helpTooltip"  [static]="true"
      [iconType]="'info'" (click)="toggleHelp()"></app-gphc-icon>
    }
  </div>

  @if (question.type === AnswerType.FreeText) {
    <h2 class="label"
      [innerHTML]="question.title"
      [id]="'labelFor-'+ question.id"
      [class.has-help-text]="!!question.body"
      (click)="setFocus()"
    > </h2>
  }

  <app-collapsible [trigger]="helpVisible" class="help-block">
    <div class="help-text" [innerHTML]="question.body">
    </div>
  </app-collapsible>

  <app-form-question-control
    (infoChanged)="onInfoChanged($event)"
    [question]="question"
    [form]="form"
    [readonly]="readonly"
  ></app-form-question-control>

</div>